import React, { useState, useEffect, useCallback } from 'react';
import { TextField, Button, CircularProgress } from '@mui/material';
import AuditLogTable from '../components/AuditLogTable';
import api from '../utils/api';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ eventType: '', userId: '', startDate: '', endDate: '' });

  const fetchAuditLogs = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/audit-logs', { params: filters });
      setLogs(response.data);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchAuditLogs();
  }, [fetchAuditLogs]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <h1>Audit Logs</h1>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <TextField
          label="Event Type"
          name="eventType"
          value={filters.eventType}
          onChange={handleFilterChange}
          size="small"
        />
        <TextField
          label="User ID"
          name="userId"
          value={filters.userId}
          onChange={handleFilterChange}
          size="small"
        />
        <TextField
          label="Start Date"
          name="startDate"
          type="date"
          value={filters.startDate}
          onChange={handleFilterChange}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          label="End Date"
          name="endDate"
          type="date"
          value={filters.endDate}
          onChange={handleFilterChange}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <Button variant="contained" onClick={fetchAuditLogs}>
          Apply Filters
        </Button>
      </div>
      {loading ? (
        <CircularProgress />
      ) : logs.length > 0 ? (
        <AuditLogTable logs={logs} />
      ) : (
        <p>No logs found for the selected filters.</p>
      )}
    </div>
  );
};

export default AuditLogs;